import { createTheme, responsiveFontSizes } from '@material-ui/core';

const theme = responsiveFontSizes(createTheme({
  palette: {
    primary: {
      main: '#036ba1',
      light: '#1694d2',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#114359',
      contrastText: '#ffffff',
    },
    background: {
      default: '#ffffff',
    },
    neutral: {
      main: '#7d7d7d',
    },
  },
  typography: {
    fontFamily: [
      'Roboto',
      'Quicksand',
      'sans-serif',
    ].join(','),
    h1: {
      fontFamily: 'Quicksand',
      fontWeight: 500,
      fontSize: '4.3rem',
    },
    h2: {
      fontFamily: 'Quicksand',
      fontSize: '3.5rem',
    },
    h3: {
      fontFamily: 'Quicksand',
      fontSize: '3rem',
    },
    h4: {
      fontFamily: 'Quicksand',
      fontSize: '2.5rem',
    },
    h5: {
      fontFamily: 'Quicksand',
      fontSize: '1.6rem',
    },
    h6: {
      fontFamily: 'Quicksand',
      fontSize: '1.2rem',
    },
    body2: { fontWeight: 300 },
    caption: { color: '#7d7d7d' },
    button: {
      fontWeight: 700,
      fontFamily: 'Quicksand',
    },
  },
  breakpoints: {
    values: {
      xs: 500,
      sm: 640,
      md: 960,
      lg: 1200,
      xl: 1536,
    },
  },
  overrides: {
    MuiAccordion: {
      root: {
        boxShadow: 'none',
        '&:not(:last-child)': {
          borderBottom: 0,
        },
        '&:before': {
          display: 'none',
        },
        '&$expanded': {
          margin: 'auto',
          border: '1px solid rgba(0, 0, 0, .125)',
        },
      },
    },
  },
}));

export default theme;
